/* 
 	* 指令下发组件 
 	* 描述:设置终端闹钟上报模式
 	* 创建时间：2017-07-11
 	* 创建人：ShujuanSun
*/
<template>
    <div>
		<form class="form-horizontal">
			<div class="form-group  pt10px">
			<label class="col-sm-3 control-label"><span class="red pr5px">*</span>选择模式</label>
			<div class="col-sm-9">
			    <span  class="pr10px">
			      <input type="radio" name="t" value="0" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">间隔模式</div></label>
			    </span>
			    <span  class="pr10px">
			      <input type="radio" name="t" value="1" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">经典闹钟模式</div></label>
			    </span>
			    <span  class="pr10px">
			      <input type="radio" name="t" value="2" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">时段闹钟模式</div></label>
			    </span>
			    <span >
			      <input type="radio" name="t" value="3" v-model="timeMode">
			      <label class="control-label"><div class="weight_n">星期闹铃模式</div></label>
			    </span>
				</div>
			</div>
			<div class="form-group" v-if="timeMode==0">
			   	<label class="col-sm-3 control-label"><span class="red pr5px">*</span>唤醒间隔</label>
			   	<div class="col-sm-8">
			   		<span class="f_left pt5px">每</span>
					<div class="col-sm-4">
			   		<input type="text" class="form-control " v-model="hour" placeholder="HH"/>	
					</div>
			   		<span class="f_left pt5px">小时</span>
					<div class="col-sm-5">
			   		<input type="text" class="form-control" v-model="min" placeholder="mm"/>
					</div>	
			   		<span class="f_left pt5px">分钟</span>
			   		<span class="dis_block pt5px orange_t  clear">不得小于5分钟</span>				
			   	</div>
			</div>
			<div  v-if="timeMode==1">
				<div class="form-group">
					<label class="col-sm-3 control-label"><span class="red pr5px">*</span>间隔天数</label>
					<div class="col-sm-8">
						<input type="text" class="form-control  " v-model="durationDays"/>
						<span  class="dis_block pt5px orange_t">范围1~7</span>
					</div>
				</div>
			    <div class="form-group">
					<label class="col-sm-3 control-label"><span class="red pr5px">*</span>唤醒时间</label>
					<div class="col-sm-8">
						<input type="text" class="form-control " v-model="duration1" placeholder="HH:mm"/>
					</div>
				</div>
			</div>
			<div class="form-group" v-if="timeMode==2">
				<label class=" col-sm-3 control-label"> <span class="red pr5px">*</span> 每天指定唤醒时段（最多5个）</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" placeholder="HH:mm,HH:mm,HH:mm,HH:mm,HH:mm" v-model="durationStr"/>
				</div>
			</div>
			<div  v-if="timeMode==3">
				<div class="form-group">
					<label class="col-sm-3 control-label"><span class="red pr5px">*</span>星期</label>
			<div class="col-sm-9">
			    <span  class="pr15px">
				      <input type="checkbox" v-model="mon"/>
				      <label class="control-label"><div class="weight_n">周一</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="tue"/>
				      <label class="control-label"><div class="weight_n">周二</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="wed"/>
				      <label class="control-label"><div class="weight_n">周三</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="thu"/>
				      <label class="control-label"><div class="weight_n">周四</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="fri"/>
				      <label class="control-label"><div class="weight_n">周五</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sat"/>
				      <label class="control-label"><div class="weight_n">周六</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sun"/>
				      <label class="control-label"><div class="weight_n">周日</div></label>
				   </span></div>
				</div>
				<div class="form-group">
					<label class="control-label col-sm-3"><span class="red pr5px">*</span>唤醒时间</label>
					<div class="col-sm-8">
						<input type="text" class="form-control" placeholder="HH:mm" v-model="duration3"/>

					</div>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label">上报模式</label>
			    <div class="col-sm-8">
			    	<div class="col-sm-4">
			    		<input type="radio" name="u" value="0" v-model="upMode">
			      		<label class="control-label"> <div class="weight_n">正常模式</div></label>
			    	</div>
			     	<div class="col-sm-4">
			    		<input type="radio" name="u" value="1" v-model="upMode">
			      		<label class="control-label"><div class="weight_n">精准模式</div></label>
			    	</div>
			    </div>
		    </div>
		    <div class="form-group">
		   		<label class="col-sm-3 control-label">最大工作时间</label>
		   		<div class="col-sm-8">
		   			<input type="text" class="form-control" v-model="worktime"/>
		   			<span  class="dis_block pt5px orange_t">单位秒，范围在180~1800</span>
		   		</div>
		 
		    </div>
		    <div class="form-group">
		   		<label class="col-sm-3 control-label">报警开关</label>
		   		<div class="col-sm-8">
			    	<div class="col-sm-4">
			    		<input type="radio" name="l" value="1" v-model="lock">
			      		<label class="control-label"><div class="weight_n">开</div></label>
			    	</div>
			     	<div class="col-sm-4">
			    		<input type="radio" name="l" value="0" v-model="lock">
			      		<label class="control-label"><div class="weight_n">关</div></label>
			    	</div>
			    </div>
		    </div>
			<div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pr10px" >
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
	
		</form>
    </div>	
</template>
<script>
	export default {
		name: "InsBKAlarmClock",
		data() {
			return {
				timeMode :"0",            //timeMode
				upMode:"0",            //上报模式
				worktime:"",				//最大工作时间
				lock:"1",			//报警开关
				//timeMode==0
				hour:'',
				min:'', 
				//timeMode==1
				durationDays:'',	//间隔天数
				duration1:'',		//唤醒时间
				//timeMode==2
				durationStr:'',
				//timeMode==3
				sat:0,
				fri:0,
				thu:0,
				wed:0,
				tue:0,
				mon:0,
				sun:0,
				duration3:'',
				//
				alertMsg:''
				 
				
			};	
		},
		props:['from','delCmd'],
		watch:{
			timeMode(val){
				this.alertMsg = ''
				this.upMode = "0"
				this.worktime = ""
				this.lock = '1'
				if(val==0){
					this.hour = ''
					this.min = ''
				}else if(val==1){
					this.durationDays = ''
					this.duration1 = ''
				}else if(val == 2){
					this.durationStr = ''
				}else if(val == 3){
					this.sat = 0
					this.fri = 0
					this.thu = 0
					this.wed = 0
					this.tue = 0
					this.mon = 0
					this.sun = 0
					this.duration3 = ''
				}
			},
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.timeMode = 0;
				this.upMode = 0;
				this.lock = 1;
				this.alertMsg = ''
				this.hour = ''
				this.min = ''
				this.worktime = ''
			},
			compareFunc(t1,t2){
				let h1 = t1.split(':')[0]
				let m1 = t1.split(':')[1]
				let h2 = t2.split(':')[0]
				let m2 = t2.split(":")[1]
			//	console.log(Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)))
				return Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)) >= 5
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				const that = this
				if(this.timeMode==0){
					//mode1
					let hour = /^(?:(?:0?|1)\d|2[0-3])$/.test(that.hour)
					let min = /^0?\d$|^[1-5]\d$/.test(that.min)
					let compare = Number(this.hour) * 60 + Number(this.min) >= 5
					if(hour && min && compare){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒间隔填写不正确'
						return
					}
				}else if(this.timeMode == 1){
					//mode2   
					let durationDays = /^[1-7]$/.test(that.durationDays)
					let duration1 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.duration1)
					if(durationDays){
						this.alertMsg = ''
					}else{
						this.alertMsg = '间隔天数填写不正确'
						return
					}
					if(duration1){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时间填写不正确'
						return
					}
				}else if(this.timeMode == 2){
					//mode3
					let resStr = this.durationStr.replace(/\s*/g, "")  //去掉空格
				//	console.log(resStr)
					let durationStr = /^((?:(?:0|1)\d|2[0-3]):[0-5]\d\,){0,4}(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(resStr)
					if(durationStr){
						let arr = resStr.split(',');
						if(arr.length >= 2){
							for(let i = 0,l = arr.length; i < l - 1; i ++){
								let compare = this.compareFunc(arr[i],arr[i + 1])
								if(compare){
									this.alertMsg = ''
								}else{
									this.alertMsg = '请从小到大输入时段，且间隔不小于5分钟'
									return
								}
							}
						}
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时段填写不正确'
						return
					}
				}else if(this.timeMode==3){
					//mode4
					let duration3 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.duration3) 
					let r6 = this.sat || this.mon || this.tue || this.wed || this.thu || this.fri || this.sun
					if(duration3){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时间填写不正确'
						return
					}
					if(r6){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请选择星期'
						return
					}
				}else{
					return
				}
				//common-------worktime  180-1800
				if(this.worktime==''){
					this.alertMsg = ''
				}else{
					let r2 = /^1[8-9][0-9]$|^[2-9]\d{2}$|^1[0-7]\d{2}$|^1800$/.test(that.worktime)
					if(r2){
						this.alertMsg = ''
					}else{
						this.alertMsg = '最大工作时间填写不正确'
						return
					}
				}
				
				let arr = [],duration0,hour,min;
			//	console.log(/^\d{2}$/.test(this.hour))
			//	console.log(/^\d{2}$/.test(this.min))
				hour = /^\d{2}$/.test(this.hour) ? this.hour : '0' + this.hour
				min = /^\d{2}$/.test(this.min) ? this.min : '0' + this.min
				duration0 = hour +':' + min
			//	console.log(duration0)
				switch (this.timeMode){
					case '0'://间隔模式：           [上报模式],[报警开关],0,[唤醒间隔-小时],[唤醒间隔-分钟],[最大工作时间]
					//arr = ['SETPRM','0B',this.upMode,this.lock,0,this.hour,this.min]
						arr = ['SETPRM','0B',this.upMode,this.lock,0,duration0]
						break;
					case '1'://经典闹钟：           [上报模式],[报警开关],1,[间隔天数],[唤醒时间],[最大工作时间]
						arr = ['SETPRM','0B', this.upMode,this.lock,1,this.durationDays, this.duration1]
						break;
					case '2'://时段闹钟（若只有一个唤醒时段，其他时段以字符串“FF”预留，共5组）：
						arr = ['SETPRM','0B', this.upMode,this.lock,2]//[上报模式],[报警开关],2,[唤醒时段1],[唤醒时段2],[唤醒时段3],[唤醒时段4],[唤醒时段5],[最大工作时间]
						let dArr = this.durationStr.split(',') 
						let tmpArr = ["FF","FF","FF","FF","FF"]
						for(let i = 0,l = dArr.length; i < l; i ++){
							 tmpArr[i] = dArr[i]
						}
						arr=arr.concat(tmpArr)
						break;
					case '3'://星期闹钟（无论周几，选中为1，不选为0）： [上报模式],[报警开关],3,[周六],[周五],[周四],[周三],[周二],[周一],[周日],[唤醒时间],[最大工作时间]
						arr = ['SETPRM','0B', this.upMode,this.lock,3,this.sat?'1':'0', this.fri?'1':'0', this.thu?'1':'0', this.wed?'1':'0', this.tue?'1':'0', this.mon?'1':'0', this.sun?'1':'0', this.duration3]
						break;
				}
				if(this.worktime!=''){
					arr.push(this.worktime)
				} 
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
				
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsBKAlarmClock.vue?6ea4563e